export default __webpack_public_path__ + "static/MediaContentSeven-939e03bbf7f4b776b53c13221bb6d8d1.webp";